import { selectIsUuidBasedProject } from 'core/userContext';
import { useSelector } from 'react-redux';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';
import { LookupRequest, LookupResponse } from '../types';

const USER_LOOKUP_API = '/users/profiles/getUserData';

const useUserLookupQuery = (lookupRequest?: LookupRequest) =>
  useRestQuery<LookupResponse, LookupRequest>(USER_LOOKUP_API, lookupRequest, {
    enabled: !!lookupRequest,
    retry: false,
    refetchOnWindowFocus: false,
  });

export const useUserKeyLookupQuery = (lookupRequest?: LookupRequest) => {
  const { data, isLoading, isError } = useUserLookupQuery(lookupRequest);
  const isUuidBasedProject = useSelector(selectIsUuidBasedProject);
  const userKey = isUuidBasedProject ? data?.itblUserId : data?.email;
  return {
    userKey,
    isLoading,
    isError,
  };
};
